<script>
    /*
     * We only handle option objects:
     * { value: {}, id: "", text: "" } 
     */

    export let options     = []     /* the options to display */
    export let selected    = null   /* an option */
    export let onChange    = () => false
    export let onCancel    = () => false
    export let dropDownMenu = false

    export let text         /* default text */
    export let noOption = false
    export let fluid    = false
    export let type     = 'selection' /* button */
    export let error    = false
    export let disabled = false

    let active   = false
    let visible  = false
    let tmp      = selected
    let invertColor = dropDownMenu

    $: defaultText = selected && selected.text || text
    $: dropDownOpen = invertColor

    function toggleState(e) {
        if (dropDownMenu)   invertColor = !invertColor
        active  = !active
        visible = !visible
        if(active)
            tmp = selected
        e.target.focus()
    }

    function itemSelected(evt, it) {
        if (dropDownMenu) invertColor = true
        evt.stopPropagation() //prevents reopening the dropdown

        const changed = it !== selected
        // if(changed) console.log('from:', (selected ? selected.id : '∅') , 'to:', (it ? it.id : '∅'))

        active   = false
        visible  = false
        selected = it
        tmp      = it

        if(changed) onChange(selected, evt)
    }

    function cancel() {
        active  = false
        visible = false
        onCancel()
    }

    function findIndex(it) {

        const len = options.length
        const last  = idx => idx === len -1
        const first = idx => idx === 0
        const next  = idx => last(idx)  ? 0       : idx + 1
        const prev  = idx => first(idx) ? len - 1 : idx - 1 

        if(!it)
            return {
                idx  : -1,
                next : 0,
                prev : len - 1
            }
        
        const idx = options.findIndex(op => op === it)
        return {
            idx  : idx,
            next : next(idx),
            prev : prev(idx)
        }
    }

    function tmpNext() {
        const idx = findIndex(tmp)
        tmp = options.find((op, i) => i === idx.next)
    }

    function tmpPrevious() {
        const idx = findIndex(tmp)
        tmp = options.find((op, i) => i === idx.prev)
    }

    function keydown(e) {
        switch(e.key) {
            case 'Escape': 
                cancel(e)
                break
            case 'Enter':
                if(active)  itemSelected(e, tmp)
                else        toggleState(e) 
                break
            case 'ArrowDown':
                tmpNext()
                break
            case 'ArrowUp':
                tmpPrevious()
                break
        }
    }

</script>

<style>
    .item.active {
        border: none !important;
    }

    .text {
        font-weight: bold;
    }

    .dropdown {
        justify-content: flex-start;
    }

</style>

<div class:fluid 
     class:error
     class:active 
     class:visible 
     class:disabled
     class="ui {type} dropdown" 
     tabindex="0" 
     on:blur={cancel}
     on:click={ toggleState } on:keydown={ keydown }
     style={`${ dropDownOpen ? `background: #AF0E93; color: white !important;` : `color:black !important;`}`}>

    <!-- <input type="hidden" name="gender"> -->

    <i class="dropdown icon" ></i>
    <div class="default text" style={`${ dropDownOpen ? `color: white !important;` : `color:black !important;`}`}>{ defaultText }</div>
    <div class="menu" class:visible style={ visible ? 'display: block !important;' : '' }>
        {#if noOption}
            <div class="item" on:click={ e => itemSelected(e, null) }>--</div>
        {/if}
        {#each options as it}
            <div class="item {tmp && tmp.id === it.id ? 'active selected' : ''}" 
                 class:disabled={it.disabled}
                 on:click={ e => itemSelected(e, it) }>{ it.text }</div>
        {/each}
    </div>
</div>